var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "120px",
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号码",
      prop: "userName"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.isEdit
    },
    model: {
      value: _vm.form.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "租户内账号",
      prop: "tenantUserName"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.tenantUserName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tenantUserName", $$v);
      },
      expression: "form.tenantUserName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "租户内人员姓名",
      prop: "tenantNickName"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.tenantNickName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tenantNickName", $$v);
      },
      expression: "form.tenantNickName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "邮箱",
      prop: "email"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("返回")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };